module.exports = __webpack_public_path__ + "static/media/appstore_image_stickers.566ceb71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/appstore_image_stickers.jpg
// module id = 231
// module chunks = 0